import { ReporteCompensacionesComponent } from './reporte-compensaciones.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
    { path: '', component: ReporteCompensacionesComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ReporteCompensacionesRouting { }
